import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EndoMultiToothExamDataModel} from '../../models/forms/custom/mti/endo-multi-tooth-exam-data.model';
import {EndoMultiToothExamTeethInExamDataModel} from '../../models/forms/custom/mti/endo-multi-tooth-exam-teeth-in-exam-data.model';
import {EndoMultiToothExamAutoFillConfigurationModel} from '../../models/forms/custom/mti/endo-multi-tooth-exam-auto-fill-configuration.model';
import {OrderUpdateModel} from '../../models/order-update.model';
import {MtiPriorExamModel} from '../../modules/forms/custom/mti/dialog/mti-prior-exam-tooth-dialog/models/mti-prior-exam.model';
import {EndoMultiToothExamCavityDataModel} from '../../models/forms/custom/mti/endo-multi-tooth-exam-cavity-data.model';
import {EndoMultiToothExamSurfaceDataModel} from '../../models/forms/custom/mti/endo-multi-tooth-exam-surface-data.model';
import {EndoMultiToothExamSurfaceAutofillConfigurationModel} from '../../models/forms/custom/mti/endo-multi-tooth-exam-surface-autofill-configuration.model';
import {EndoMultiToothExamToothDataModel} from '../../models/forms/custom/mti/endo-multi-tooth-exam-tooth-data.model';

@Injectable({
  providedIn: 'root'
})
export class MtiService {

  constructor(private http: HttpClient) {

  }

  getExams(patientId: string) {
    return this.http.get<EndoMultiToothExamDataModel[]>(`api/mti/get-patient-exams/${patientId}`);
  }

  saveExam(exam: EndoMultiToothExamDataModel) {
    return this.http.post<EndoMultiToothExamDataModel>(`api/mti/save-exam`, exam);
  }

  getSingleTooth(MTEToothID: string) {
    return this.http.get<EndoMultiToothExamTeethInExamDataModel>(`api/mti/get-single-tooth/${MTEToothID}`);
  }

  saveTooth(toothModel: EndoMultiToothExamTeethInExamDataModel) {
    return this.http.post<EndoMultiToothExamTeethInExamDataModel>(`api/mti/save-tooth`, toothModel);
  }

  deleteTooth(tooth: EndoMultiToothExamTeethInExamDataModel) {
    return this.http.post<EndoMultiToothExamTeethInExamDataModel>(`api/mti/delete-tooth`, tooth);
  }

  updateTeethOrder(models: OrderUpdateModel[]) {
    return this.http.post<void>(`api/mti/update-teeth-order`, models);
  }

  getExamAutoFills() {
    return this.http.get<EndoMultiToothExamAutoFillConfigurationModel[]>(`api/mti/get-exam-autofills`);
  }

  saveExamAutoFillX(model: EndoMultiToothExamAutoFillConfigurationModel) {
    return this.http.post<EndoMultiToothExamAutoFillConfigurationModel>(`api/mti/save-exam-autofill`, model);
  }
  saveExamAutoFill(model: EndoMultiToothExamAutoFillConfigurationModel[]) {
    return this.http.post<EndoMultiToothExamAutoFillConfigurationModel[]>(`api/mti/save-exam-autofill`, model);
  }


  deleteExamAutoFill(model: EndoMultiToothExamAutoFillConfigurationModel) {
    return this.http.post<void>(`api/mti/delete-exam-autofill`, model);
  }

  associatePriorTeeth(mteid: string, models: MtiPriorExamModel[]) {
    return this.http.post<void>(`api/mti/associate-prior-teeth/${mteid}`, models);
  }

  addCarie(carie: EndoMultiToothExamCavityDataModel) {
    return this.http.post<EndoMultiToothExamCavityDataModel>(`api/mti/add-carie`, carie);
  }

  removeCarie(carie: EndoMultiToothExamCavityDataModel) {
    return this.http.post<void>(`api/mti/remove-carie`, carie);
  }

  addSurfaceProbingDepth(mod: EndoMultiToothExamSurfaceDataModel) {
    return this.http.post<EndoMultiToothExamSurfaceDataModel>(`api/mti/add-surface-probing-depth`, mod);
  }

  getSurfaceProbingAutofills() {
    return this.http.get<EndoMultiToothExamSurfaceAutofillConfigurationModel[]>(`api/mti/get-surface-probing-autofills`);
  }

  saveSurfaceProbingAutofills(autofills: EndoMultiToothExamSurfaceAutofillConfigurationModel[]) {
    return this.http.post<EndoMultiToothExamSurfaceAutofillConfigurationModel[]>(`api/mti/save-surface-probing-autofills`, autofills);
  }

  downloadTeeth(teeth: EndoMultiToothExamTeethInExamDataModel[], workItemId: string) {
    return this.http.post<string>(`api/mti/download-teeth/${workItemId}`, teeth);
  }

  deleteExam(selectedExam: EndoMultiToothExamDataModel) {
    return this.http.post<void>(`api/mti/delete-exam`, selectedExam);
  }

  associateToForm(caseWorkItemFormsId: string, MTEID: string) {
    return this.http.get<void>(`api/mti/associate-exam-to-form/${caseWorkItemFormsId}/${MTEID}`);
  }
}
